import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20editorial%20backdrop%20with%20warm%20amber%20and%20copper%20gradient%20accents%2C%20subtle%20geometric%20patterns%2C%20professional%20news%20and%20media%20atmosphere%2C%20deep%20rich%20shadows%2C%20cinematic%20composition%2C%20warm%20highlight%20details%2C%20luxurious%20dark%20texture&width=1800&height=1200&seq=hero-bg&orientation=landscape"
          alt="51黑料网 Hero 背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-primary-500/20 border border-primary-500/30 rounded-full text-sm font-medium text-primary-300 mb-6 whitespace-nowrap">
              {siteInfo.heroTag}
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-background-50 font-heading leading-tight mb-4">
              {siteInfo.heroTitle}
            </h1>

            <p className="text-lg md:text-xl text-background-100/80 font-heading mb-6">
              {siteInfo.heroSlogan}
            </p>

            <p className="text-sm md:text-base text-background-100/60 leading-relaxed mb-8 max-w-xl lg:max-w-none">
              {siteInfo.heroIntro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {siteInfo.heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-400 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-100/50 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={siteInfo.heroCtaPrimary.href}
                className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                {siteInfo.heroCtaPrimary.text}
              </a>
              <a
                href={siteInfo.heroCtaSecondary.href}
                className="px-8 py-3 border border-background-100/30 hover:border-primary-500/50 text-background-50 hover:text-primary-300 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                {siteInfo.heroCtaSecondary.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:block">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20illustration%20of%20digital%20content%20aggregation%2C%20warm%20amber%20and%20copper%20accent%20lines%20connecting%20floating%20abstract%20document%20cards%2C%20professional%20data%20visualization%20aesthetic%2C%20cinematic%20lighting%2C%20rich%20dark%20background%2C%20sophisticated%20design%20elements&width=900&height=675&seq=hero-visual&orientation=landscape"
                alt="51黑料网 分区导航主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 border border-background-100/10 rounded-2xl pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}